import { createAsyncThunk } from '@reduxjs/toolkit';
import { store } from 'app/store';
import { mainServiceWithCredentials } from 'shared/services/http';
import { AxiosResponse } from 'axios';
import { toast } from 'react-toastify';
import { ICreatedPrize, IPostAdminAward } from './types';

const createNewAwardThunk = createAsyncThunk(
  'competitionsApi/createNewAwardThunk',
  async (requestData: IPostAdminAward.Request, thunkAPI) => {
    try {
      const data: AxiosResponse<IPostAdminAward.Response> = await mainServiceWithCredentials.post(
        'competitions/admin/competition/prize/',
        requestData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${store.getState().auth.token}`,
          },
        },
      );

      toast.success('Награда сохранена');

      return data.data;
    } catch (e) {
      toast.error('Произошла ошибка при сохранении награды');
      thunkAPI.rejectWithValue(undefined);
    }
  },
);

const getNewAwardThunk = createAsyncThunk('competitionsApi/getNewAwardThunk', async (prize_id: number) => {
  try {
    const data: AxiosResponse<ICreatedPrize> = await mainServiceWithCredentials.get(
      `competitions/admin/competition/prize/${prize_id}`,
      {
        headers: {
          Authorization: `Bearer ${store.getState().auth.token}`,
        },
      },
    );
    return data.data;
  } catch (e) {}
});

const updateAwardThunk = createAsyncThunk(
  'competitionsApi/updateAwardThunk',
  async (requestData: IPostAdminAward.Request & { id: number }, thunkAPI) => {
    try {
      const data: AxiosResponse<IPostAdminAward.Response> = await mainServiceWithCredentials.patch(
        `competitions/admin/competition/prize/${requestData.id}`,
        requestData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${store.getState().auth.token}`,
          },
        },
      );

      toast.success('Награда сохранена');

      return data.data;
    } catch (e) {
      toast.error('Произошла ошибка при сохранении награды');
      thunkAPI.rejectWithValue(undefined);
    }
  },
);

export { createNewAwardThunk, getNewAwardThunk, updateAwardThunk };
